import { render } from "./ReportLoading.vue?vue&type=template&id=285ae05e&scoped=true"
import script from "./ReportLoading.vue?vue&type=script&lang=js"
export * from "./ReportLoading.vue?vue&type=script&lang=js"

import "./ReportLoading.vue?vue&type=style&index=0&id=285ae05e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285ae05e"]])

export default __exports__